<template >
  <div class="home">
    <!-- <div class="headNav">
      <head-nav ref="headNav"></head-nav>
    </div> -->

    <div class="main_content">
      <div class="leftNav" >
        <left-menu></left-menu>
      </div>

      <div class="right-content">
        <div style="position: absolute;width: 100%;top: 0;z-index: 100;">

          <tabs></tabs>
        </div>

        <div class="content" >
          <div style="height: 100%;overflow-y: auto;">
            <!--<keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>-->
            <keep-alive>
              <router-view ></router-view>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import HeadNav from './headNav.vue'
  import LeftMenu from './leftNav.vue'
  import Tabs from './tabs.vue';

  export default {
    name: 'home',
    data () {
      return {
        keepAliveArr:[]
      }
    },
    components: {
      HeadNav, LeftMenu, Tabs
    },
    mounted () {
      const self = this;
      console.log('this.$vnode',this)
      this.$router.beforeEach((to, from, next) => {
        console.log('tp',to.fullPath)
        if(to.params.delKeepAlive){
           var testTag =  "-"+to.fullPath.substring( to.fullPath.indexOf("/home/") + 6 );
           //console.log('testTag',testTag)
           for(var i=self.$children.length-1;i>=0;i--){
              if(self.$children[i].$vnode.tag.indexOf(testTag) != -1){
                //console.log('activated-i',i);
                //console.log('self.$children[i].$route.fullPath',self.$children);
                var key  = self.$children[i].$vnode.componentOptions.Ctor.cid;
                if(self.$children[i].$vnode.parent&&self.$children[i].$vnode.parent.componentInstance.cache[key]){
                  delete self.$children[i].$vnode.parent.componentInstance.cache[key];
                  var cidIndex = self.$children[i].$vnode.parent.componentInstance.keys.indexOf(key);
                  self.$children[i].$vnode.parent.componentInstance.keys.splice(cidIndex,1);
                };
              }
            }
        };
        next();
      });
    },

    watch: {
      $route (to, from) {

        //this.$children.splice(this.$children.length-1,1);
        //console.log('this.$vnodehome',this)

        /* console.log('to.name',to.name)
        console.log('this.menu',this.menu)
        //this.init()
        var item = this.$$getArrayByTarget(this.menu,'name',to.name)[0];
        console.log('item',item)
        this.default_index = item['id']; */
      },

    },
    beforeDestroy() {
    },
  }
</script>
<style>
  .home{
    width: 100%;
    height: 100%;
  }

  .headNav{
    width: 100%;
    height: 8%;
    overflow: hidden;
  }

  .main_content{
    width: 100%;
    height: 100%;
    position: relative;
  }

  .content {
    /*background: #f1f2f7;*/
    background: #F8F9FC;
    padding: 0px 16px;
    height: 100%;
    box-sizing: border-box;
    padding-top: 40px;
    overflow-y: auto;
    position: relative;
  }

  .right-content {
    float: left;
    width: 87%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .leftNav{
    float: left;
    width: 13%;
    height: 100%;
    position: relative;
  }

  .el-select__tags{height: 85%;overflow-y: auto;}
  .el-input__inner{max-height: 28px;}

  .el-button--info{background-color: #243847;border-color: #243847;}
  .el-date-editor .el-range__icon,.el-date-editor .el-range-separator,.el-input__icon{line-height: 20px;}


  .demo-form-inline {
    display: inline-block;
    float: right;
  }
  .btm-action {
    margin-top: 20px;
    text-align: center;
  }
  .actions-top {
    height: 46px;
  }
  .field_item {
    float: left;
    padding: 15px 15px 0!important;
    min-height: 28px;
  }

  .allSearch{padding: 35px 15px;text-align: initial;box-sizing: border-box;}
  .allSearch .searchBox{border-left: 8px solid #1C2B36;box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08);background-color: #fff;position: relative;padding-bottom: 20px;}
  .allSearch .btnBox{padding: 16px;border-bottom: 1px solid #DEDEDE;display: flex;}
  .allSearch .searchCon{overflow: hidden;transition: all 0.3s;}
  .allSearch .open{position: absolute;right: 0;top: 0;padding: 20px;}
  .allSearch .notice{display: flex;align-items: center;flex: 1;justify-content: center;padding-right: 112px;}
  .allSearch .notice img{margin-right: 10px;}

  .h210{min-height: 60px;max-height: 120px;}
  .hA{max-height: 300px;min-height: 60px;}

  .allSearch .el-button--primary{background-color: #00B7EE;border-color: #00B7EE;}
  .allSearch .el-button--primary.is-plain{color: #00B7EE;background-color: #fff;}

  .tableCon{height: 71%;}
  
  
    #admin-left::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    #admin-left::-webkit-scrollbar-thumb {
    	transition: alll 0.3s;
        background-color: rgba(193, 193, 193, 0.1);
        background-clip: padding-box;
        border-width: 3px;
        border-color: transparent;
        border-style: solid;
        border-radius: 5px;
    }
    #admin-left::-webkit-scrollbar-thumb:hover {
        background-color: rgba(189, 189, 189, 0.3);
        background-clip: border-box;
    }

</style>



// WEBPACK FOOTER //
// src/layout/home.vue